<ng-container *transloco="let t">
  <div class="main-content">
    <div class="data-section" id="data-section">
      <div class="title-row">
        <h3>{{ t(TITLE) }}</h3>
      </div>

      <div class="content-container">
        <div class="actions-row">
          <p-button
            [icon]="
              'pi pi-refresh' +
              (((dataLoading$ | async) ?? true) ? ' pi-spin' : '')
            "
            [disabled]="(dataLoading$ | async) ?? true"
            (click)="refreshData()"
          />

          <!-- <p-button
            icon="pi pi-filter"
            severity="info"
            [outlined]="!filtersDialogVisible"
            [disabled]="(dataLoading$ | async) ?? true"
            (click)="toggleFilters()"
            [label]="appliedFiltersCount"
          /> -->

          <input
            #dataSearch
            type="text"
            pInputText
            id="search-input"
            (input)="dataTable.filterGlobal(dataSearch.value, 'contains')"
            [placeholder]="t(SEARCH_PLACEHOLDER)"
            class="search-input"
          />

          <p-button
            [label]="t(ADD_BUTTON_LABEL)"
            icon="pi pi-plus"
            class="add-record-button"
            (click)="openFormDialog()"
          />

          <p-button
            icon="pi pi-list-check"
            severity="secondary"
            [disabled]="selectedRows.length === 0"
            (click)="batchMenuElement.toggle($event)"
          />

          <p-menu
            #batchMenuElement
            [model]="batchMenu"
            [popup]="true"
            appendTo="body"
          />
        </div>

        <p-skeleton
          class="skeleton-loader"
          height="100%"
          width="100%"
          [class.visible]="(dataLoadingUI$ | async) ?? true"
        />

        <p-table
          #dataTable
          class="table"
          id="table"
          [value]="data"
          [(selection)]="selectedRows"
          [rowHover]="true"
          [paginator]="true"
          [rows]="10"
          [rowsPerPageOptions]="[5, 10, 15, 20, 50]"
          sortMode="single"
          selectionMode="multiple"
          [rowTrackBy]="_dataTrackBy"
          [metaKeySelection]="true"
          [resizableColumns]="true"
          columnResizeMode="fit"
          [globalFilterFields]="dataFilterFields"
          stripedRows
          [scrollable]="true"
          [class.visible]="!((dataLoadingUI$ | async) ?? true)"
        >
          <ng-template #header>
            <tr>
              <th style="width: 3rem"><p-tableHeaderCheckbox /></th>

              @for (col of columns; track col.field) {
                @if (col.visible ?? true) {
                  <th [pSortableColumn]="col.field" pResizableColumn>
                    <div class="table-header-row">
                      <span class="header-label">{{
                        t(col.header, col.headerParams)
                      }}</span>
                      <div class="header-buttons">
                        <p-sortIcon [field]="col.field" />
                      </div>
                    </div>
                  </th>
                }
              }
            </tr>
          </ng-template>
          <ng-template #body let-record let-rowIndex="rowIndex">
            <tr
              [pSelectableRow]="record"
              [pSelectableRowIndex]="rowIndex"
              (contextmenu)="$event.preventDefault(); openFormDialog(record)"
              (longPress)="openFormDialog(record)"
              appLongPress
            >
              <td (click)="$event.stopPropagation()">
                <p-tableCheckbox [value]="record" />
              </td>
              @for (col of columns; track col.field) {
                @if (col.visible ?? true) {
                  <td>
                    <!-- CELLA -->
                    @if (col.wrapper) {
                      <ng-container
                        *ngComponentOutlet="
                          col.wrapper;
                          inputs: parseWrapperInputs(col, [
                            record,
                            getCellData(col, record),
                          ])
                        "
                      ></ng-container>
                    } @else {
                      <span [innerHTML]="getCellData(col, record)"></span>
                    }
                  </td>
                }
              }
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <!--? FORM DIALOG  --------------------------------->
  <p-dialog
    [header]="
      isNewRecordDialog
        ? t(NEW_RECORD_TITLE)
        : t(EDIT_RECORD_TITLE, { code: formDialogData.code })
    "
    [modal]="true"
    [(visible)]="formDialogVisible"
    [style]="{ width: 'min(35rem, 90vw)' }"
    [maximizable]="false"
    [draggable]="false"
    appendTo="body"
    [focusOnShow]="true"
    [dismissableMask]="false"
    [maskStyle]="{ 'backdrop-filter': 'blur(10px)' }"
    styleClass="form-dialog"
    (onHide)="dialogForm.reset(formDialogData)"
  >
    <form class="dialog-form" #dialogForm="ngForm">
      <!--? CODE ----------------------------->
      <p-floatlabel variant="in">
        <input
          #taskCodeInput="ngModel"
          pInputText
          id="task-code-input"
          name="code"
          [(ngModel)]="formDialogData.code"
          autocomplete="off"
          required
          [disabled]="(dataLoading$ | async) ?? true"
        />
        <label for="task-code-input">
          {{ t("code") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? NOTES ---------------------------------->
      <p-floatlabel variant="in">
        <textarea
          pTextarea
          #taskNotesInput="ngModel"
          id="task-notes-input"
          name="notes"
          [(ngModel)]="formDialogData.notes"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          styleClass="w-full"
          rows="4"
          style="resize: none"
        ></textarea>
        <label for="task-notes-input">
          {{ t("notes") }}
        </label>
      </p-floatlabel>

      <!--? EST. TIME ----------------------------->
      <p-floatlabel variant="in">
        <p-inputnumber
          #taskCodeInput="ngModel"
          id="task-expectedDuration-input"
          name="expectedDuration"
          [(ngModel)]="formDialogData.expectedDuration"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          min="0"
          step="1"
          [showButtons]="true"
          buttonLayout="stacked"
        />
        <label for="task-expectedDuration-input">
          {{ t("expectedDurationMinutes") }}
        </label>
      </p-floatlabel>

      <!--? LINK ----------------------------->
      <p-floatlabel variant="in">
        <input
          #taskCodeInput="ngModel"
          pInputText
          id="task-link-input"
          name="link"
          [(ngModel)]="formDialogData.link"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
        />
        <label for="task-link-input">
          {{ t("link") }}
        </label>
      </p-floatlabel>
    </form>

    <ng-template #footer>
      @if (!isNewRecordDialog) {
        <p-button
          [label]="t('delete')"
          severity="danger"
          (click)="deleteRecord()"
          class="delete-button"
          [outlined]="true"
          [disabled]="(dataLoading$ | async) ?? true"
        />
      }
      <p-button
        [label]="t('cancel')"
        severity="secondary"
        (click)="hideFormDialog()"
        [outlined]="true"
      />
      <p-button
        [label]="t('save')"
        severity="primary"
        (click)="saveRecord()"
        [disabled]="((dataLoading$ | async) ?? true) || !dialogForm.valid"
      />
    </ng-template>
  </p-dialog>

  <!--? FILTERS DIALOG --------------------------------->
  <!--<p-dialog
    [header]="t(FILTERS_TITLE)"
    [(visible)]="filtersDialogVisible"
    [style]="{
      width: 'min(30rem, 80vw)',
      'min-width': '430px',
      'max-width': '90vw',
      'max-height': '90vh',
      'min-height': '10rem',
    }"
    [maximizable]="false"
    [draggable]="true"
    appendTo="body"
    styleClass="filter-dialog"
    (onHide)="onFiltersDialogHide()"
  >
    <form class="filter-form" #filterForm="ngForm"></form>

    <ng-template #footer>
      <p-button
        [label]="t('clear')"
        severity="danger"
        [outlined]="true"
        (click)="dataFilters.values = {}; refreshData()"
        [disabled]="(dataLoading$ | async) ?? true"
      />
      <p-button
        [label]="t('apply')"
        severity="primary"
        (click)="refreshData()"
        [disabled]="(dataLoading$ | async) ?? true"
      />
    </ng-template>
  </p-dialog>-->
</ng-container>
